@if (!tunnelConnected() && !loading()) {
<div class="tunnel-message">
    <p-message severity="warn" [closable]="false" icon="fa-solid fa-plug-circle-xmark mr-2">
        <strong>Device Tunnel Unavailable</strong>
        <p class="mt-1 mb-0 text-sm">The device is not connected via WebSocket tunnel. Credential management requires a live connection to the device.</p>
    </p-message>
</div>
} @else {
<app-section-card title="Stored Credentials" subtitle="Encrypted secrets such as API keys and device passwords" icon="fa fa-key" [count]="loading() ? null : items().length" [flush]="true">
    <div actions class="header-actions">
        <p-button icon="fa fa-plus" [text]="true" severity="success" size="small" ariaLabel="Add credential" (onClick)="showAddDialog()" pTooltip="Add credential"></p-button>
        <p-button icon="fa fa-refresh" [text]="true" severity="info" size="small" ariaLabel="Refresh credentials" [loading]="loading()" (onClick)="loadData()" pTooltip="Refresh credentials"></p-button>
    </div>

    @if (errorMessage(); as err) {
    <div class="app-card-pad">
        <p-message severity="error" [closable]="false" class="w-full">{{ err }}</p-message>
    </div>
    }

    <p-table
        [value]="items()"
        [loading]="loading()"
        [paginator]="true"
        [rows]="15"
        [rowsPerPageOptions]="[10, 15, 25, 50]"
        [showCurrentPageReport]="true"
        currentPageReportTemplate="Showing {first} to {last} of {totalRecords} credentials"
        [rowHover]="true"
        [globalFilterFields]="['key']"
        sortField="key"
        [sortOrder]="1"
    >
        <ng-template #header>
            <tr>
                <th pSortableColumn="key" style="width: 30%">
                    Key
                    <p-sorticon field="key"></p-sorticon>
                </th>
                <th>Value</th>
                <th style="width: 100px">Status</th>
                <th style="width: 180px">Actions</th>
            </tr>
        </ng-template>

        <ng-template #body let-item>
            <tr>
                <td>
                    <code class="key-code">{{ item.key }}</code>
                </td>
                <td class="value-cell">
                    @if (item.showValue && item.actualValue) {
                    <span class="value-text actual-value">{{ item.actualValue }}</span>
                    } @else {
                    <span class="value-text masked-value">{{ item.maskedValue }}</span>
                    }
                </td>
                <td>
                    @if (item.hasValue) {
                    <p-tag value="Set" severity="success"></p-tag>
                    } @else {
                    <p-tag value="Empty" severity="warn"></p-tag>
                    }
                </td>
                <td>
                    <div class="action-buttons">
                        <p-button
                            [icon]="item.showValue ? 'fa fa-eye-slash' : 'fa fa-eye'"
                            (onClick)="toggleShowValue(item)"
                            [text]="true"
                            severity="info"
                            size="small"
                            [ariaLabel]="item.showValue ? 'Hide value' : 'Show value'"
                            [pTooltip]="item.showValue ? 'Hide value' : 'Show value'"
                        ></p-button>
                        <p-button icon="fa fa-copy" [text]="true" severity="info" size="small" ariaLabel="Copy credential" (onClick)="copyToClipboard(item)" pTooltip="Copy to clipboard"></p-button>
                        <p-button icon="fa fa-pencil" [text]="true" severity="warn" size="small" ariaLabel="Edit credential" (onClick)="showEditDialog(item)" pTooltip="Edit credential"></p-button>
                        <p-button icon="fa fa-trash" [text]="true" severity="danger" size="small" ariaLabel="Delete credential" (onClick)="confirmDelete(item)" pTooltip="Delete credential"></p-button>
                    </div>
                </td>
            </tr>
        </ng-template>

        <ng-template #emptymessage>
            <tr>
                <td colspan="4">
                    <app-empty-state icon="fa fa-key" title="No credentials stored" actionLabel="Add your first credential" actionIcon="fa fa-plus" (action)="showAddDialog()" />
                </td>
            </tr>
        </ng-template>
    </p-table>
</app-section-card>
}

<p-dialog [header]="dialogMode === 'add' ? 'Add Credential' : 'Edit Credential'" [modal]="true" [(visible)]="dialogVisible" [style]="{ width: '450px' }" [closable]="true">
    <div class="dialog-content">
        <div class="field">
            <label for="key">Key</label>
            <input pInputText id="key" [(ngModel)]="editingItem.key" [disabled]="dialogMode === 'edit'" class="w-full" placeholder="Enter credential key (e.g., api_key, password)" />
        </div>

        <div class="field">
            <label for="value">{{ dialogMode === 'edit' ? 'New Value' : 'Value' }}</label>
            <p-password id="value" [(ngModel)]="editingItem.value" [toggleMask]="true" [feedback]="false" class="w-full" inputStyleClass="w-full" placeholder="Enter secret value"></p-password>
        </div>

        <div class="field">
            <label for="confirmValue">Confirm Value</label>
            <p-password id="confirmValue" [(ngModel)]="editingItem.confirmValue" [toggleMask]="true" [feedback]="false" class="w-full" inputStyleClass="w-full" placeholder="Re-enter secret value"></p-password>
        </div>

        @if (dialogMode === 'edit') {
        <div class="info-message">
            <i class="pi pi-info-circle"></i>
            <span>Leave empty to keep the current value unchanged.</span>
        </div>
        }
    </div>

    <ng-template #footer>
        <p-button label="Cancel" severity="secondary" (onClick)="dialogVisible = false"></p-button>
        <p-button [label]="dialogMode === 'add' ? 'Add' : 'Save'" (onClick)="saveItem()"></p-button>
    </ng-template>
</p-dialog>

<p-confirmdialog></p-confirmdialog>
